<script >
import { hexToRgbA } from "./helpers";


    export let universalMode = false;
    export let fg = "black";
    let bg = "rgba(255,255,255,.95)";

</script>



<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 496 496">
  <path fill={universalMode ?  'black' : fg} data-name="Universal Access" d="M256,8C119.033,8,8,119.033,8,256S119.033,504,256,504,504,392.967,504,256,392.967,8,256,8ZM464,256Zm-64.406-78.66A20,20,0,0,1,384.725,201.4c-29.865,7.051-57.839,13.286-85.6,16.751.679,111.33,12.654,128.456,26.969,165.116a24,24,0,0,1-44.709,17.465c-9.559-24.467-18.089-42.949-23.8-85.12h-3.164c-5.721,42.206-14.269,60.706-23.8,85.12a24,24,0,1,1-44.71-17.465c14.33-36.686,26.29-53.837,26.969-165.116-27.758-3.465-55.732-9.7-85.6-16.751a20,20,0,0,1,9.192-38.93c104.768,24.736,134.447,24.7,239.066,0a20,20,0,0,1,24.06,14.869ZM217.806,134.194A38.194,38.194,0,1,1,256,172.388,38.194,38.194,0,0,1,217.806,134.194Z" transform="translate(-8 -8)"/>
</svg>


<style>
     svg{
         height: 1.3rem;
         width: 1.3rem;
     }

</style>


